import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EnrollmentListShell from "../components/EnrollmentListShell";
import FiltersInlineSlot from "../components/FiltersInlineSlot";
import UserEnrollmentRow from "../components/UserEnrollmentRow";
import { useEnrolledUsersList } from "../hooks/useEnrolledUsersList";
import {
  buildEnrollTypeOptions,
  buildStatusEnrollmentOptions,
} from "../config/filterOptions";

const PAGE_SIZE = 10;

interface EnrolledUsersTabProps {
  corporateId: string | number;
  objectId: number;
}

const EnrolledUsersTab: React.FC<EnrolledUsersTabProps> = ({
  corporateId,
  objectId,
}) => {
  const { t } = useTranslation("users-and-groups");
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const [enrollType, setEnrollType] = useState("");

  const { items, totalItems, totalPages, isLoading } = useEnrolledUsersList({
    corporateId,
    objectId,
    page,
    pageSize: PAGE_SIZE,
    search: search || undefined,
    status: status || undefined,
    enrollType: enrollType || undefined,
  });

  return (
    <EnrollmentListShell
      search={search}
      onSearchSubmit={(v) => {
        setSearch(v);
        setPage(1);
      }}
      filtersSlot={
        <FiltersInlineSlot
          filters={[
            {
              id: "enrolled-users-status",
              label: String(t("filters.status")),
              value: status,
              options: buildStatusEnrollmentOptions(t),
              onChange: (v) => {
                setStatus(v);
                setPage(1);
              },
            },
            {
              id: "enrolled-users-type",
              label: String(t("filters.type")),
              value: enrollType,
              options: buildEnrollTypeOptions(t),
              onChange: (v) => {
                setEnrollType(v);
                setPage(1);
              },
            },
          ]}
        />
      }
      isLoading={isLoading}
      isEmpty={items.length === 0}
      emptyLabel={String(t("empty.enrolled-users"))}
      page={page}
      pageSize={PAGE_SIZE}
      totalItems={totalItems}
      totalPages={totalPages}
      onPageChange={setPage}
    >
      {items.map((user) => (
        <UserEnrollmentRow
          key={`${user.userId}-${user.enrollId ?? ""}`}
          user={user}
          onArrowClick={(u) => {
            // TODO: navigare al detail enrollment del singolo utente
            console.log("[enrolled-users] arrow click", u);
          }}
        />
      ))}
    </EnrollmentListShell>
  );
};

export default EnrolledUsersTab;
